module.exports = {"cookies":"Cookies","help":"Ayuda","privacy":"Privacidad","signInButtonText":"Iniciar sesión con un Adobe ID","termsOfUse":"Condiciones de uso","updated":"ACTUALIZADO"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/es_es.json
// module id = 945
// module chunks = 0